import { COMMON_ROUTES } from "routes/common";

export const ROUTES = {
  ...COMMON_ROUTES,
  ALL_OFFERS: '/offers',
  AUCTIONS: '/auctions',
  AUCTION_CREATE: '/program/:programId/auction_create',
  AUCTION_EDIT: '/auction/:auctionId/program/:programId',
  CALCULATOR: '/calc',
  CATALOG: '/calc/catalogs/:cId/sheets/:sId',
  CATALOGS: '/calc/catalogs',
  CATALOGSC: '/calc/catsc/:cId/sheets/:sId',
  CATALOGSSC: '/calc/catsc',
  CATALOGSTZR: '/calc/cattzr',
  CATALOGTZR: '/calc/cattzr/:cId/sheets/:sId',
  FORGOT_PASSWORD: '/forgotpassword',
  FORMULA: '/calc/formula/:fId',
  FORMULAS: '/calc/formulas',
  FORMULA_CREATE: '/calc/formula/',
  NEEDS: '/products/:pId/needs',
  NEW_PASSWORD: '/newpassword',
  ORDERS: '/orders',
  PRODUCT: '/products/:pId',
  PRODUCTS: '/products',
  PRODUCT_OFFER: '/products/:pId/offers/:offerId',
  PRODUCT_OFFERS: '/products/:pId/offers',
  PROGRAM: '/program',
  PROGRAMS: '/programs',
  PROGRAM_CREATE: '/program/product/:pId/',
  PROGRAM_EDIT: '/program/:programId',
  RESTORE_PASSWORD: '/restorepassword',
  STAGE: '/auction/:auctionId/stage/:stageId',
  SUPPLIER: '/supplier/:sId',
  SUPPLIERS: '/suppliers',
  TERMS: '/calc/terms',
  USER: '/supplier-user/:uId',
  ERROR: '/error',
  DETAIL_CALC: '/detail-calc',
  REGULAR_DEMANDS: '/regular-demands',
};
